import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

import {ExitPopupContentWrapper, ImageWrapper} from './styles'

export const ExitPopupSkeleton = () => {
  return (
    <ExitPopupContentWrapper>
      <ImageWrapper>
        <SkeletonLoader height="100%" />
      </ImageWrapper>
      <Box display="flex" justifyContent="space-between" gap="s400">
        <div>
          <SkeletonLoader width={155} />
          <SkeletonLoader width={100} />
        </div>
        <div>
          <SkeletonLoader width={55} />
          <SkeletonLoader width={79} />
        </div>
      </Box>
    </ExitPopupContentWrapper>
  )
}
